<template>
    <div class="c-pagination flex-between-center" :class="{'s-border': border}" :style="{'background': background}">
    	<div class="page-size flex-center">
    		<span class="">共{{total}}条</span>
    		<c-select v-model="pageSize" :options="pageSizeOptions" :default-option="false"></c-select>
    	</div>
    	<div class="page flex-center">
    		<a class="tf tf-prev" :class="{'z-dis': pageIndex <= 1}" @click="update(1)"></a>
    		<a class="tf tf-tri-left" :class="{'z-dis': pageIndex <= 1}" @click="update(pageIndex - 1)"></a>
    		<span>第</span>
    		<input v-model="pageIndex" type="text" @keyup.enter="update(pageIndex)">
    		<span>页</span>
    		<span>共{{pageCount}}页</span>
    		<a class="tf tf-tri-right" :class="{'z-dis': pageIndex >= pageCount}" @click="update(pageIndex + 1)"></a>
    		<a class="tf tf-next" :class="{'z-dis': pageIndex >= pageCount}" @click="update(pageCount)"></a>
    		<a class="tf tf-refresh" @click="update(pageIndex)"></a>
    	</div>
    </div>
</template>

<script>
	export default {
        props: {
            total: {
                type: [String, Number],
                default: 0
            },
            
            border: {
                type: Boolean,
                default: true
            },
            
            background: {
                type: String,
                default: '#fff'
            }
        },
        
        data() {
            return {
                pageIndex: 1,
                pageSize: 20,
                pageSizeOptions: [{
                    name: '10条/页',
                    value: 10
                }, {
                    name: '20条/页',
                    value: 20
                }, {
                    name: '50条/页',
                    value: 50
                }, {
                    name: '100条/页',
                    value: 100
                }]
            }
        },
		
		computed: {
			pageCount() {
				return Math.ceil(parseInt(this.total) / this.pageSize) || 1;
			}
		},
        
        watch: {
            pageSize() {
				this.update(1);
            }
        },
        
		methods: {
            update(page) {
				page = parseInt(page || this.pageIndex) || 1;
				page = page < 1 ? 1 : page > this.pageCount ? this.pageCount : page;
                
                this.pageIndex = page;
                this.$emit('handle', {
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                });
            }
		}
	};
</script>

<style lang="stylus" scoped>
	.c-pagination {
		position: relative;
		height: 46px;
		padding: 0 20px 0 10px;
		margin-top: -1px;
		font-size: 12px;
        
        &.s-border {
            border-top: 1px solid #ddd;
        }
		
		.page-size {
			> span {
				margin: 0 5px;
				color: #666;
			}
			
			.c-select {
				width: 74px;
				height: 26px;
				padding: 0 8px;
				
				span {
					font-size: 12px;
				}
				
				&-options-item {
					line-height: 26px;
				}
			}
		}
		
		.page {
			> span {
				margin: 0 5px;
				color: #777;
			}
			
			input {
				width: 26px;
				height: 18px;
				border: 1px solid #ACB8C0;
				text-align: center;
                background: #fff;
			}
			
			a {
				padding: 4px;
				color: #000;
				
				&:hover {
					theme-color(main);
				}
				
				&.z-dis {
					color: #bbb;
					cursor: not-allowed;
				}
			}
		}
	}
</style>
